import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Users, Navigation, Phone, Truck, Loader2 } from "lucide-react";

const RADII = [100, 150, 250, 500];

export default function NearbyDrivers({ loadId }) {
  const [radius, setRadius] = useState(150);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api.get(`/matches/drivers`, { params: { load_id: loadId, radius } })
      .then((r) => { if (active) setData(r.data); })
      .catch(() => { if (active) setData({ drivers: [], count: 0 }); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [loadId, radius]);

  return (
    <div className="card-base p-6" data-testid="nearby-drivers">
      <div className="flex items-center justify-between mb-1">
        <div className="font-display text-lg font-bold text-navy flex items-center gap-2">
          <Users size={18} className="text-gold" /> Drivers near pickup
        </div>
      </div>
      <div className="flex items-center gap-1.5 mb-4 flex-wrap">
        {RADII.map((r) => (
          <button key={r} onClick={() => setRadius(r)}
            className={`text-[11px] font-bold px-2.5 py-1 rounded-full ${radius === r ? "bg-navy text-white" : "bg-slate-100 text-slate-500 hover:text-navy"}`}
            data-testid={`radius-${r}`}>
            {r} mi
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-sm text-slate-500 flex items-center gap-2"><Loader2 size={14} className="animate-spin" /> Searching…</div>
      ) : data.count === 0 ? (
        <div className="text-sm text-slate-400" data-testid="no-drivers">No available drivers within {radius} mi.</div>
      ) : (
        <>
          <div className="text-sm text-slate-600 mb-3">
            <span className="font-bold text-navy" data-testid="driver-count">{data.count}</span> driver(s) within {radius} mi
          </div>
          <div className="space-y-2">
            {data.drivers.map((d) => (
              <div key={d.user_id} className="flex items-center justify-between border border-slate-100 rounded-md p-3" data-testid={`nearby-driver-${d.user_id}`}>
                <div className="min-w-0">
                  <div className="font-semibold text-slate-900 text-sm">{d.name}</div>
                  <div className="text-xs text-slate-500 flex items-center gap-2 flex-wrap mt-0.5">
                    <span className="inline-flex items-center gap-1"><Navigation size={11} className="text-gold" /> {d.distance_mi} mi</span>
                    {d.equipment_type && <span className="inline-flex items-center gap-1 capitalize"><Truck size={11} /> {d.equipment_type}</span>}
                    {d.phone && <span className="inline-flex items-center gap-1"><Phone size={11} /> {d.phone}</span>}
                  </div>
                </div>
                <span className="text-[10px] uppercase tracking-wider font-bold text-slate-400">{d.home_zip}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
